import { Component, inject } from '@angular/core';
import { ActivityPerNurseryService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityPerNurseryCreateDto,
  ActivityPerNurseryDto,
  ActivityPerNurseryExcelDownloadDto,
  ActivityPerNurseryUpdateDto,
} from '../proxy/controlling/dtos/activity-per-nursery';
import { ACTIVITYPERNURSERY_CONFIG, ACTIVITYPERNURSERY_FIELDS } from './activity-per-nursery.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activity-per-nursery',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ActivityPerNurseryService, ConfirmationService],
  templateUrl: './activity-per-nursery.html',
  styleUrl: './activity-per-nursery.scss',
})
export class ActivityPerNursery extends BaseHierarchicalCrudComponent<
  ActivityPerNurseryDto,
  ActivityPerNurseryCreateDto,
  ActivityPerNurseryUpdateDto,
  ActivityPerNurseryExcelDownloadDto
> {
  service = inject(ActivityPerNurseryService);
  config = ACTIVITYPERNURSERY_CONFIG;
  fields = ACTIVITYPERNURSERY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityPerNurseryDto): ActivityPerNurseryUpdateDto {
    return {
      nurseryActivityParameterId: data.nurseryActivityParameterId,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityPerNursery';
  }
}
